var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AccordBlock',[_c('template',{slot:"header"},[_c('div',{class:{'admin-edit-item': _vm.$store.getters.getUserProfile.isAdmin || _vm.checkImpersonate()}},[_c('div',{staticClass:"admin-edit",on:{"click":function($event){return _vm.editTranslate([
        'ex_sendFrom',
      ])}}}),_vm._v(" "+_vm._s(_vm.$t('ex_sendFrom.localization_value.value'))+" ")])]),_c('template',{slot:"body"},[_c('PickupInfo',{attrs:{"ex":_vm.ex,"isEdit":_vm.isEdit}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }